import HttpCodes from 'http-status-codes';
import { extractError } from '@/requests/axios.utilities';
import { isForbidden, isRequestWithStatus } from '@/utilities/http.utilities';

const TEMPLATE_INSTANCE_NOT_FOUND_MESSAGE = 'No TemplateInstance found for id';

function getErrorMessage(error: unknown): string {
  const extracted = extractError(error);
  if (extracted instanceof Error) {
    return extracted.message;
  }
  return typeof extracted === 'string' ? extracted : '';
}

/**
 * True when template metadata cannot be read due to missing permissions.
 * Instance reads are filtered by template GUID permission, so getInstance returns 404 with
 * "No TemplateInstance found for id" when the user lacks template read access.
 */
export function isTemplateInformationInaccessible(error: unknown): boolean {
  if (isForbidden(error)) {
    return true;
  }
  return (
    isRequestWithStatus(error, HttpCodes.NOT_FOUND) &&
    getErrorMessage(error).includes(TEMPLATE_INSTANCE_NOT_FOUND_MESSAGE)
  );
}
